import React from "react";
import AssetManager from "Components/Drawers/AssetManager";

const AssetViewer = () => {
    return (
        <div>
            <AssetManager />
        </div>
    );
};

export default AssetViewer;
